import Binocular from "@assets/ExerciseListingPage/Binocular.png"
import Monocular from "@assets/ExerciseListingPage/Monocular.png"
import NeuroVision from "@assets/ExerciseListingPage/NeuroVision.png"
import VR from "@assets/ExerciseListingPage/VR.png"

export const exerciseTypeIconMapping = {
    Binocular: Binocular,
    BaseInBaseOut: Binocular,
    Monocular: Monocular,
    NeuroVision: NeuroVision,
    vr: VR,
}
